module.exports = __webpack_public_path__ + "img/female.e1850360.png";